module.exports = __webpack_public_path__ + "img/PL08011.cb406630.png";